import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'clsx';
import type { ReactNode } from 'react';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import { ConditionsPlaceholder } from '../../placeholders';
import styles from './document-condition.module.css';

export function DocumentConditions(): ReactNode {
  const { type } = usePdfPreviewContext();

  if (type === 'invoice') {
    return <InvoiceConditions />;
  }

  return null;
}

function InvoiceConditions(): ReactNode {
  const { formatMessage } = useIntl();
  const { displayLanguage, settings } = usePdfPreviewContext();

  return (
    <div className="mb-8">
      <ConditionsPlaceholder>
        {settings?.transactionType ? (
          <p className="body-1" data-testid="pdf-preview-transaction-type">
            <FormattedMessage
              id="pdf-preview.transaction-type.label"
              values={{ language: displayLanguage }}
            />
            {formatMessage(
              {
                id: `pdf-preview.transaction-type.${settings.transactionType}`,
              },
              { language: displayLanguage }
            )}
          </p>
        ) : null}

        {settings?.vatPaymentCondition && settings.vatPaymentCondition !== 'exempt' ? (
          <p className="body-1" data-testid="pdf-preview-vat-payment-condition">
            <FormattedMessage
              id="pdf-preview.payment-condition.label"
              values={{ language: displayLanguage }}
            />
            {formatMessage(
              { id: `pdf-preview.payment-condition.${settings.vatPaymentCondition}` },
              { language: displayLanguage }
            )}
          </p>
        ) : null}

        {settings?.discountConditions ? (
          <p
            className={cx('body-1', styles.condition)}
            data-testid="pdf-preview-discount-condition"
          >
            {settings.discountConditions}
          </p>
        ) : null}

        {settings?.latePaymentPenalties ? (
          <p className={cx('body-1', styles.condition)} data-testid="pdf-preview-payment-penalty">
            {settings.latePaymentPenalties}
          </p>
        ) : null}

        {settings?.legalFixedCompensation ? (
          <p
            className={cx('body-1', styles.condition)}
            data-testid="pdf-preview-fixed-compensation"
          >
            {settings.legalFixedCompensation}
          </p>
        ) : null}
      </ConditionsPlaceholder>
    </div>
  );
}
